import { Box, Button, SystemIcon } from "@justworkshr/milo-components";
import { HealthAppStatus } from "../utils/constants";
import { convertTitleToDataTestId } from "../utils/utils";
import styles from "../HealthInsuranceApplication.module.css";

interface IHealthStepProps {
  title: string;
  iconBackgroundColor?: string;
  description?: React.ReactNode;
  mobileDescription?: React.ReactNode;
  icon?: React.ReactNode;
  buttonText?: string;
  status?: HealthAppStatus;
  updateStepAndHandleRedirect: (redirectPath: string) => void;
  handleEditClick: (redirectPath: string, stepNumber: number) => void;
}

const HealthStep = (props: IHealthStepProps) => {
  const {
    title,
    description,
    mobileDescription,
    icon,
    buttonText,
    iconBackgroundColor,
    status,
    updateStepAndHandleRedirect,
    handleEditClick,
  } = props;

  const testTitle = convertTitleToDataTestId(title);

  return (
    <Box
      border={{
        borderColor: "neutralSubtle",
        borderWidth: "sm",
        borderRadius: "md",
      }}
    >
      {status === HealthAppStatus.Active && (
        <div className={`${styles.step} ${styles.active}`}>
          <div
            className={styles.iconContainer}
            style={{ backgroundColor: iconBackgroundColor }}
          >
            {icon}
          </div>

          <div className={styles.texts}>
            <span>{title}</span>

            <div className={styles.mobileDescription}>{mobileDescription}</div>

            <div className={styles.desktopDescription}>{description}</div>

            <Button
              data-testid={`start-button-${testTitle}`}
              onClick={updateStepAndHandleRedirect}
            >
              {buttonText || "Start"}
            </Button>
          </div>
        </div>
      )}

      {status === HealthAppStatus.Completed && (
        <div className={`${styles.step} ${styles.completed}`}>
          <SystemIcon
            iconName="check-circle-inverted"
            color="success"
            title="person"
            size="medium"
          />

          <span className={styles.completedTitle}>{title}</span>

          <Button
            data-testid={`edit-button-${testTitle}`}
            variant="ghost"
            leftIcon="edit"
            onClick={handleEditClick}
          >
            Edit
          </Button>
        </div>
      )}

      {status === HealthAppStatus.Pending && (
        <div
          className={`${styles.step} ${styles.pending}`}
          data-testid={`pending-${testTitle}`}
        >
          <span className={styles.pendingTitle}>{title}</span>
        </div>
      )}
    </Box>
  );
};

export default HealthStep;
